import pick from 'lodash/pick'
import omit from 'lodash/omit'

export const transformPatient = patient => {
    const relevant = omit(patient, [
        'agreementId',
        'createdByEmailId',
        'createdBy',
        'createdDateTime',
        'updatedBy',
        'updatedDateTime',
    ])
    return {
        ...relevant,
        name: `${patient.lastName}, ${patient.firstName}`,
    }
}

export const transformPatients = patients => {
    if (!patients) return []
    return patients.map(patient => transformPatient(patient))
}

export const transformCollection = collection => {
    const relevant = omit(collection, [
        'createByEmailId',
        'updatedByEmailId',
        'zeissAgreementId',
        'createdBy',
        'updatedBy',
        'createdDateTime',
    ])
    return relevant
}

export const transformCollections = collections => {
    if (!collections) return []
    return collections.map(collection => transformCollection(collection))
}

export const transformPatientFiles = files => {
    if (!files) return []
    return files.map(file => {
        const relevant = pick(file, ['createdDateTime', 'updatedDateTime', 'series', 'patientId'])
        return {
            ...relevant,
            fileId: file.id,
            fileType: file.fileType.toLowerCase(),
            patient: transformPatient(file.patient),
            thumbnailId: file.thumbnail?.fileId,
            isDownloadable: true,
            updatedDateTime: file.series?.acquisitionDateTime,
        }
    })
}

export const transformCollectionFiles = files => {
    if (!files) return []
    return files.map(file => {
        const relevant = pick(file, ['thumbnailId', 'fileId', 'patientId'])
        return {
            ...relevant,
            fileType: file.fileType.toLowerCase(),
            updatedDateTime: file.lastModifiedDateTime,
            isDownloadable: true,
        }
    })
}

export const transformSharedFiles = files => {
    if (!files) return []
    return files.map(file => {
        const relevant = omit(file, ['thumbnailFileId', 'fileShareDate'])
        return {
            ...relevant,
            fileType: file.fileType?.toLowerCase(),
            thumbnailId: file.thumbnailFileId,
            updatedDateTime: file.fileShareDate,
            isShared: true,
        }
    })
}

export const transformFavoriteFiles = files => {
    if (!files) return []
    return files.map(file => {
        const relevant = omit(file, ['createdBy', 'userId', 'updatedBy'])
        return {
            ...relevant,
            fileType: file.fileType?.toLowerCase(),
            isDownloadable: true,
        }
    })
}

export const transformSharedFilesWithSummary = ({ data, count }) => {
    return {
        grouped: data.map(d => {
            return {
                ...d,
                files: transformSharedFiles(d.files),
            }
        }),
        files: transformSharedFiles(
            data
                .map(d =>
                    d.files.map(f => {
                        return {
                            ...f,
                            patient: {
                                id: d.patientId,
                                name: d.patientName,
                            },
                        }
                    })
                )
                .flat()
        ),
        summary: count,
    }
}
